import _ from 'underscore'

export default function buildDefaultDevices(productModelVersion) {
  return productModelVersion.device_template_assignments.map(assignment => {
    const template = productModelVersion.device_templates.find(deviceTemplate => {
      return deviceTemplate.id == assignment.device_template_id
    })

    const filteredTemplate = _.omit(template, ['name', 'id'])

    return {
      ...filteredTemplate,
      deviceTemplateId: template.id,
      deviceTemplateAssignmentId: assignment.id,
      deviceTemplateName: assignment.name || template.name,
      name: assignment.name || template.name,
      optional: assignment.optional,
      deviceSpecificationId: null,
      deviceSpecificationVersion: null,
      masterSlaveConfig: 'standalone',
      masterId: null,
      protocolType: null,
      protocolInformation: {},
      configId: null,
      things: []
    }
  })
}
